// eslint-disable-next-line import/extensions
import backgroundImage from '@/components/Common/MainBackground/assets/background.jpg';

// @vue/component
export default {
  name: 'MainBackground',

  data() {
    return {
      backgroundImage,
    };
  },
};
